module.exports = __webpack_public_path__ + "assets/img/922191.2ed6da77.jpg";